import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "react-image-crop/dist/ReactCrop.css";
import {
  Register,
  ForgetPassword,
  Login,
  Otp,
  Home,
  Verify,
  NotFound,
  EmailSignature,
  VirtualBackground,
  Analytics,
  Contacts,
  UpgradePlan,
  Payment,
  Setting,
  Card,
  CreateCard,
  UpdatedCard,
  ResetPassword,
  Support,
  CreateBackground,
  CreateSignature,
  UpdatedBackground,
  UpdatedSignature,
  CreateContact,
  UpdatedContact,
} from "./pages";
import { PrivateRoutes, PublicRoutes } from "./utils";
import { Provider } from "react-redux";
import store from "./store";

const App = () => {
  return (
    <Provider store={store}>
      <Router>
        <div className="hidden bg-red-400 bg-primary"></div>
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route path="/" element={<Home />} />
            <Route path="/signatures" element={<EmailSignature />}></Route>
            <Route path="/backgrounds" element={<VirtualBackground />}></Route>
            <Route path="/analytics" element={<Analytics />}></Route>
            <Route path="/contacts" element={<Contacts />}></Route>
            <Route path="/plan/upgrade" element={<UpgradePlan />}></Route>
            <Route path="/payment/:paymentId" element={<Payment />}></Route>
            <Route path="/settings" element={<Setting />}></Route>
            <Route path="/support" element={<Support />}></Route>
            <Route path="/card/create" element={<CreateCard />}></Route>
            <Route path="/backgrounds/create" element={<CreateBackground />} />
            <Route path="/signatures/create" element={<CreateSignature />} />
            <Route path="/contacts/create" element={<CreateContact />} />
            <Route
              path="/card/update/:cardId"
              element={<UpdatedCard />}
            ></Route>
            <Route
              path="/backgrounds/update/:backgroundId"
              element={<UpdatedBackground />}
            ></Route>
            <Route
              path="/signatures/update/:emailSignatureId"
              element={<UpdatedSignature />}
            ></Route>
            <Route
              path="/contacts/update/:contactId"
              element={<UpdatedContact />}
            ></Route>
          </Route>
          <Route element={<PublicRoutes />}>
            <Route path="/register" element={<Register />} />
            <Route path="/forgot" element={<ForgetPassword />} />
            <Route path="/login" element={<Login />} />
            <Route path="/otp/:email" element={<Otp />} />
            <Route path="/v1/auth/email/confirm/:token" element={<Verify />} />
            <Route
              path="/v1/users/password/reset/:token"
              element={<ResetPassword />}
            />
          </Route>
          <Route path="/me/:slug" element={<Card />} />
          <Route path="/tome/:slug" element={<Card />} />
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </Router>
    </Provider>
  );
};

export default App;
